module.exports = __webpack_public_path__ + "img/hammer.3d9ffcbd.png";